import { render, staticRenderFns } from "./BillPos.vue?vue&type=template&id=f3b627e6&scoped=true"
import script from "./BillPos.vue?vue&type=script&lang=js"
export * from "./BillPos.vue?vue&type=script&lang=js"
import style0 from "./BillPos.vue?vue&type=style&index=0&id=f3b627e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b627e6",
  null
  
)

export default component.exports